<template>
    <div class="rootBox">
        <div class="tableBox">
            <div class="itemBox" v-show="titleText===$t(`message.ratesItem.taxConsultation`)">
                <div class="msgOrInp">
                    <div class="introduce">
                        <el-select v-model="titleText">
                            <el-option v-for="(item,index) in options" :key="item.val" :label="item.text" :value="item.text">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="inpBox">
                        <el-form :model="initData">
                            <el-form-item prop="taxNumber" class="taxInp">
                                <el-input clearable v-model="initData.taxNumber" :placeholder="$t(`message.ratesItem.holderBig`)" @blur="floatNumMax('taxNumber')" type="number"></el-input>
                                <span class="unitSmall">{{$t("message.tabs.ratesSmall")}}</span>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="explain" :title="$t(`message.ratesItem.accountingRuleA`)">{{$t(`message.tabs.explain`)}}&nbsp; {{$t(`message.ratesItem.accountingRuleA`)}}</div>
                </div>
                <div class="resultBox">
                    <div class="showPrice">{{stopUndefined(taxPrice)}} </div>
                    <div class="unitText"> &nbsp; {{$t(`message.tabs.ratesSmall`)}}</div>
                </div>
            </div>
            <div class="itemBox" v-show="titleText===$t(`message.ratesItem.consultant`)">
                <div class="msgOrInp">
                    <div class="introduce">
                        <el-select v-model="titleText">
                            <el-option v-for="(item,index) in options" :key="item.val" :label="item.text" :value="item.text">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="inpBox">
                        <el-form :model="initData" :inline="true" :rules="initDataRules" class="selectDifficulty">
                            <el-form-item class="beforeSel">
                                <el-select v-model="difficulty">
                                    <el-option label="普通" :value="1.5"></el-option>
                                    <el-option label="疑难" :value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="taxAdvisorNumber" class="taxInp">
                                <el-input clearable v-model="initData.taxAdvisorNumber" :placeholder="$t(`message.ratesItem.holderBig`)" type="number" @blur="floatNumMax('taxAdvisorNumber')">
                                </el-input>
                                <span class="unitSmall">{{$t("message.tabs.ratesSmall")}}</span>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="explain topOne" :title="$t(`message.ratesItem.accountingRuleA`)">{{$t(`message.tabs.explain`)}}&nbsp; {{$t(`message.ratesItem.accountingRuleA`)}}</div>
                </div>
                <div class="resultBox">
                    <div class="showPrice">{{stopUndefined(taxAdvisorPrice)}}</div>
                    <div class="unitText"> &nbsp; {{$t(`message.tabs.ratesSmall`)}}</div>
                </div>
            </div>
            <div class="itemBox" v-show="titleText===$t(`message.ratesItem.taxPlanning`)">
                <div class="msgOrInp">
                    <div class="introduce">
                        <el-select v-model="titleText">
                            <el-option v-for="(item,index) in options" :key="item.val" :label="item.text" :value="item.text">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="inpBox">
                        <el-form :model="initData" :rules="initDataRules">
                            <el-form-item prop="taxPlanningNumber" class="taxInp">
                                <el-input clearable v-model="initData.taxPlanningNumber" :placeholder="$t(`message.ratesItem.holderBig`)" @blur="floatNumMax('taxPlanningNumber')" type="number"></el-input>
                                <span class="unitSmall">{{$t("message.tabs.ratesSmall")}}</span>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="explain" :title="$t(`message.ratesItem.accountingRuleA`)">{{$t(`message.tabs.explain`)}}&nbsp; {{$t(`message.ratesItem.accountingRuleA`)}}</div>
                </div>
                <div class="resultBox">
                    <div class="showPrice">{{stopUndefined(taxPlanningPrice)}}</div>
                    <div class="unitText"> &nbsp; {{$t(`message.tabs.ratesSmall`)}}</div>
                </div>
            </div>
            <div class="itemBox" v-show="titleText===$t(`message.ratesItem.taxSettlement`)">
                <div class="msgOrInp">
                    <div class="introduce">
                        <el-select v-model="titleText">
                            <el-option v-for="(item,index) in options" :key="item.val" :label="item.text" :value="item.text">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="inpBox">
                        <el-form :model="initData" :rules="initDataRules">
                            <el-form-item prop="taxCorporateIncomeNumber" class="taxInp">
                                <el-input clearable v-model="initData.taxCorporateIncomeNumber" :placeholder="$t(`message.ratesItem.holderBig`)" @blur="floatNumMax('taxCorporateIncomeNumber')" type="number"></el-input>
                                <span class="unitSmall">{{$t("message.tabs.ratesSmall")}}</span>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="explain" :title="$t(`message.ratesItem.accountingRuleA`)">{{$t(`message.tabs.explain`)}}&nbsp; {{$t(`message.ratesItem.accountingRuleA`)}}</div>
                </div>
                <div class="resultBox">
                    <div class="showPrice">{{stopUndefined(taxCorporateIncomePrice)}}</div>
                    <div class="unitText"> &nbsp; {{$t(`message.tabs.ratesSmall`)}}</div>
                </div>
            </div>
            <div class="itemBox" v-show="titleText===$t(`message.ratesItem.verification`)">
                <div class="msgOrInp">
                    <div class="introduce">
                        <el-select v-model="titleText">
                            <el-option v-for="(item,index) in options" :key="item.val" :label="item.text" :value="item.text">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="inpBox">
                        <el-form :model="initData" :rules="initDataRules">
                            <el-form-item prop="taxCorporateAssetLossNumber" class="taxInp">
                                <el-input clearable v-model="initData.taxCorporateAssetLossNumber" :placeholder="$t(`message.ratesItem.holderBig`)" @blur="floatNumMax('taxCorporateAssetLossNumber')" type="number"></el-input>
                                <span class="unitSmall">{{$t("message.tabs.ratesSmall")}}</span>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="explain" :title="$t(`message.ratesItem.accountingRuleG`)">{{$t(`message.tabs.explain`)}}&nbsp; {{$t(`message.ratesItem.accountingRuleG`)}}</div>
                </div>
                <div class="resultBox">
                    <div class="showPrice">{{stopUndefined(taxCorporateAssetLossPrice)}}</div>
                    <div class="unitText"> &nbsp; {{$t(`message.tabs.ratesSmall`)}}</div>
                </div>
            </div>
            <div class="itemBox" v-show="titleText===$t(`message.ratesItem.taxLiquidation`)">
                <div class="msgOrInp">
                    <div class="introduce">
                        <el-select v-model="titleText">
                            <el-option v-for="(item,index) in options" :key="item.val" :label="item.text" :value="item.text">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="inpBox taxInp">
                        <el-input clearable v-model="initData.taxIncrementNumber" :placeholder="$t(`message.ratesItem.holderLand`)" @input="importText('taxIncrementNumber')" type="number"></el-input>
                        <span class="landSmall">{{$t("message.tabs.landSmall")}}</span>
                    </div>
                    <div class="explain" :title="$t(`message.ratesItem.accountingRuleD`)">{{$t(`message.tabs.explain`)}}&nbsp; {{$t(`message.ratesItem.accountingRuleD`)}}</div>
                </div>
                <div class="resultBox">
                    <div class="showPrice">{{stopUndefined(taxIncrementPrice)}}</div>
                    <div class="unitText"> &nbsp; {{$t(`message.tabs.ratesSmall`)}}</div>
                </div>
            </div>
            <div class="itemBox" v-show="titleText===$t(`message.ratesItem.qyzxqs`)">
                <div class="msgOrInp">
                    <div class="introduce">
                        <el-select v-model="titleText">
                            <el-option v-for="(item,index) in options" :key="item.val" :label="item.text" :value="item.text">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="inpBox">
                        <el-form :model="initData" :rules="initDataRules">
                            <el-form-item prop="cancellationEnterpriseNumber" class="taxInp">
                                <el-input clearable v-model="initData.cancellationEnterpriseNumber" :placeholder="$t(`message.ratesItem.holderBig`)" @blur="floatNumMax('cancellationEnterpriseNumber')" type="number"></el-input>
                                <span class="unitSmall">{{$t("message.tabs.ratesSmall")}}</span>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="explain" :title="$t(`message.ratesItem.accountingRuleA`)">{{$t(`message.tabs.explain`)}}&nbsp; {{$t(`message.ratesItem.accountingRuleA`)}}</div>
                </div>
                <div class="resultBox">
                    <div class="showPrice">{{stopUndefined(cancellationEnterprisePrice)}}</div>
                    <div class="unitText"> &nbsp; {{$t(`message.tabs.ratesSmall`)}}</div>
                </div>
            </div>
            <div class="itemBox" v-show="titleText===$t(`message.ratesItem.hourly`)">
                <div class="msgOrInp">
                    <div class="introduce">
                        <el-select v-model="titleText">
                            <el-option v-for="(item,index) in options" :key="item.val" :label="item.text" :value="item.text">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="inpBox timeCharge taxInp">
                        <el-select v-model="lever">
                            <el-option label="执业等级7" :value="7"></el-option>
                            <el-option label="执业等级6" :value="6"></el-option>
                            <el-option label="执业等级5" :value="5"></el-option>
                            <el-option label="执业等级4" :value="4"></el-option>
                            <el-option label="执业等级3" :value="3"></el-option>
                            <el-option label="执业等级2" :value="2"></el-option>
                            <el-option label="执业等级1" :value="1"></el-option>
                        </el-select>
                        <el-input class="timeInp" clearable v-model="initData.travelExpenseNumber" :placeholder="$t(`message.ratesItem.holderTime`)" @input="importText('travelExpenseNumber')" type="number">
                        </el-input>
                        <span class="timeSmall">{{$t("message.tabs.timeSmall")}}</span>
                    </div>
                    <div class="explain topTwo" :title="$t(`message.ratesItem.accountingRuleE`)">{{$t(`message.tabs.explain`)}}&nbsp; {{$t(`message.ratesItem.accountingRuleE`)}}</div>
                </div>
                <div class="resultBox">
                    <div class="showPrice">{{stopUndefined(travelExpensePrice)}}</div>
                    <div class="unitText"> &nbsp;{{$t(`message.tabs.ratesSmall`)}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'taxRevenueRule',
    data() {
        return {
            //费率
            rateValueData: {
                taxValue: 2 / 10000, //税务咨询
                taxAdvisorValue: 3 / 10000, //专业税务顾问
                taxPlanningValue: 5 / 10000, //税收策划
                taxIncrementValue: 3, //土地增值税清算鉴证
            },
            //输入的价格,和上面费率的位置一致的
            initData: {
                taxNumber: '',
                taxAdvisorNumber: '',
                taxPlanningNumber: '',
                taxCorporateIncomeNumber: '',
                taxCorporateAssetLossNumber: '',
                taxIncrementNumber: '',
                cancellationEnterpriseNumber: '',
                travelExpenseNumber: ''
            },
            initDataRules: {
                taxNumber: [{ required: true, validator: this.floatNumCheck, trigger: 'change' }],
                taxAdvisorNumber: [{ required: true, validator: this.floatNumCheck, trigger: 'change' }],
                taxPlanningNumber: [{ required: true, validator: this.floatNumCheck, trigger: 'change' }],
                taxCorporateIncomeNumber: [{ required: true, validator: this.floatNumCheck, trigger: 'change' }],
                taxCorporateAssetLossNumber: [{ required: true, validator: this.floatNumCheck, trigger: 'change' }],
                taxIncrementNumber: [{ required: true, validator: this.floatNumCheck, trigger: 'change' }],
                cancellationEnterpriseNumber: [{ required: true, validator: this.floatNumCheck, trigger: 'change' }],
                travelExpenseNumber: [{ required: true, validator: this.floatNumCheck, trigger: 'change' }]
            },
            difficulty: 1.5,
            lever: 7,
            options: [{
                text: this.$t(`message.ratesItem.taxConsultation`),
                val: 0
            }, {
                text: this.$t(`message.ratesItem.consultant`),
                val: 1
            }, {
                text: this.$t(`message.ratesItem.taxPlanning`),
                val: 2
            }, {
                text: this.$t(`message.ratesItem.taxSettlement`),
                val: 3
            }, {
                text: this.$t(`message.ratesItem.verification`),
                val: 4
            }, {
                text: this.$t(`message.ratesItem.taxLiquidation`),
                val: 5
            }, {
                text: this.$t(`message.ratesItem.qyzxqs`),
                val: 6
            }, {
                text: this.$t(`message.ratesItem.hourly`),
                val: 7
            }],
            titleText: this.$t(`message.ratesItem.taxConsultation`)
        };
    },
    watch: {
        difficulty(newVal) {
            this.rateValueData.taxAdvisorValue = newVal === 1.5 ? 3 / 10000 : 4 / 10000
        },
    },
    computed: {
        //呈现的收费，和上面费率的摆放位置一致的
        taxPrice() {
            if (this.initData.taxNumber <= 0) return ''
            //X≤1亿元: 固定收费10 {{$t(`message.tabs.ratesSmall`)}}
            if (this.initData.taxNumber <= 10000) return (10).toFixed(2)
            //1亿元<X≤10亿元: 固定收费20万元
            if (this.initData.taxNumber <= 100000) return (20).toFixed(2)

            //为了避免小数精度下降，将费率和用户输入的数字转为整数，再降幂。

            //计算费率的小数位数，用于后面换成整数计算，然后再降幂
            const floatNum = (this.rateValueData.taxValue + '').split('.')[1].length
            //先升幂至没有小数，计算出大整数
            const price = ((+this.initData.taxNumber) * 100) * ((+this.rateValueData.taxValue) * Math.pow(10, floatNum))
            //返回结果并降幂
            return price / Math.pow(10, (floatNum + 2))
        },
        taxAdvisorPrice() {
            if (this.initData.taxAdvisorNumber <= 0) return ''
            if (this.initData.taxAdvisorNumber <= 10000) return (10 * this.difficulty).toFixed(2)
            if (this.initData.taxAdvisorNumber <= 100000) return (20 * this.difficulty).toFixed(2)
            const floatNum = (this.rateValueData.taxAdvisorValue + '').split('.')[1].length
            const price = ((+this.initData.taxAdvisorNumber) * 100) * ((+this.rateValueData.taxAdvisorValue) * Math.pow(10, floatNum))
            return price / Math.pow(10, (floatNum + 2))
        },
        taxPlanningPrice() {
            return this.rateValueData.taxPlanningValue * this.initData.taxPlanningNumber
        },
        taxCorporateIncomePrice() {
            /**
             * @negligible :需要减去的不计算价格的部分
             * @rate :不同价格的费率
             * @floorPrice ：底价
             * 展示价格 = 底价 + initPrice * rate
             */
            let negligible, rate, floorPrice;
            if (this.initData.taxCorporateIncomeNumber <= 50) {
                rate = 0.005
                negligible = 0
                floorPrice = 0
            } else if (this.initData.taxCorporateIncomeNumber <= 100) {
                rate = 0.01
                negligible = 50
                floorPrice = 0.5
            } else if (this.initData.taxCorporateIncomeNumber <= 500) {
                rate = 0.005
                negligible = 100
                floorPrice = 1
            } else if (this.initData.taxCorporateIncomeNumber <= 1000) {
                rate = 0.003
                negligible = 500
                floorPrice = 3
            } else if (this.initData.taxCorporateIncomeNumber <= 5000) {
                rate = 0.002
                negligible = 1000
                floorPrice = 4.5
            } else if (this.initData.taxCorporateIncomeNumber <= 10000) {
                rate = 0.0015
                negligible = 5000
                floorPrice = 12.5
            } else {
                rate = 0.0005
                negligible = 10000
                floorPrice = 65
            }
            const floatNum = (rate + '').split('.')[1].length
            const initPrice = (((+this.initData.taxCorporateIncomeNumber) * 100) - (negligible * 100)) / 100
            const price = (initPrice * 100) * (rate * Math.pow(10, floatNum)) / Math.pow(10, (floatNum + 2))
            //未加底价的价格的小数点
            const priceFloat = (price + '').indexOf('.') > 0 ? (price + '').split('.')[1].length : 2
            return (price * Math.pow(10, priceFloat) + floorPrice * Math.pow(10, priceFloat)) / Math.pow(10, priceFloat)
        },
        taxCorporateAssetLossPrice() {
            let negligible, rate, floorPrice;
            if (this.initData.taxCorporateAssetLossNumber <= 50) {
                rate = 0.005
                negligible = 0
                floorPrice = 0
            } else if (this.initData.taxCorporateAssetLossNumber <= 100) {
                rate = 0.01
                negligible = 50
                floorPrice = 0.5
            } else if (this.initData.taxCorporateAssetLossNumber <= 500) {
                rate = 0.005
                negligible = 100
                floorPrice = 1
            } else if (this.initData.taxCorporateAssetLossNumber <= 1000) {
                rate = 0.003
                negligible = 500
                floorPrice = 3
            } else if (this.initData.taxCorporateAssetLossNumber <= 5000) {
                rate = 0.002
                negligible = 1000
                floorPrice = 4.5
            } else if (this.initData.taxCorporateAssetLossNumber <= 10000) {
                rate = 0.0015
                negligible = 5000
                floorPrice = 12.5
            } else {
                rate = 0.0005
                negligible = 10000
                floorPrice = 65
            }
            const floatNum = (rate + '').split('.')[1].length
            const initPrice = (((+this.initData.taxCorporateAssetLossNumber) * 100) - (negligible * 100)) / 100
            const price = (initPrice * 100) * (rate * Math.pow(10, floatNum)) / Math.pow(10, (floatNum + 2))
            //未加底价的价格的小数点
            const priceFloat = (price + '').indexOf('.') > 0 ? (price + '').split('.')[1].length : 2
            return (price * Math.pow(10, priceFloat) + floorPrice * Math.pow(10, priceFloat)) / Math.pow(10, priceFloat)
        },
        taxIncrementPrice() {
            if (this.rateValueData.taxIncrementValue * this.initData.taxIncrementNumber <= 0) return 0
            if (this.rateValueData.taxIncrementValue * this.initData.taxIncrementNumber < 100000) return 10.00
            return this.rateValueData.taxIncrementValue * this.initData.taxIncrementNumber / 10000
        },
        cancellationEnterprisePrice() {
            let negligible, rate, floorPrice;
            if (this.initData.cancellationEnterpriseNumber <= 50) {
                rate = 0.005
                negligible = 0
                floorPrice = 0
            } else if (this.initData.cancellationEnterpriseNumber <= 100) {
                rate = 0.011
                negligible = 50
                floorPrice = 0.5
            } else if (this.initData.cancellationEnterpriseNumber <= 500) {
                rate = 0.0055
                negligible = 100
                floorPrice = 1.05
            } else if (this.initData.cancellationEnterpriseNumber <= 1000) {
                rate = 0.0033
                negligible = 500
                floorPrice = 3.25
            } else if (this.initData.cancellationEnterpriseNumber <= 5000) {
                rate = 0.0028
                negligible = 1000
                floorPrice = 4.9
            } else if (this.initData.cancellationEnterpriseNumber <= 10000) {
                rate = 0.0017
                negligible = 5000
                floorPrice = 15.9
            } else {
                rate = 0.0006
                negligible = 10000
                floorPrice = 73.65
            }
            const floatNum = (rate + '').split('.')[1].length
            const initPrice = (((+this.initData.cancellationEnterpriseNumber) * 100) - (negligible * 100)) / 100
            const price = (initPrice * 100) * (rate * Math.pow(10, floatNum)) / Math.pow(10, (floatNum + 2))
            //未加底价的价格的小数点
            const priceFloat = (price + '').indexOf('.') > 0 ? (price + '').split('.')[1].length : 2
            return (price * Math.pow(10, priceFloat) + floorPrice * Math.pow(10, priceFloat)) / Math.pow(10, priceFloat)
        },
        travelExpensePrice() {
            const obj = {
                1: 3000,
                2: 1500,
                3: 1200,
                4: 800,
                5: 600,
                6: 400,
                7: 300
            }
            return obj[this.lever] * this.initData.travelExpenseNumber / 10000
        },
    },
    methods: {
        floatNumMax(val) {
            if (this.initData[val] <= 0) {
                this.initData[val] = ''
            } else if (('' + this.initData[val]).indexOf('.') < 0) {
                this.initData[val] = this.initData[val] + '.00'
            } else if (('' + this.initData[val]).split('.')[1].length < 2) {
                this.initData[val] = this.initData[val] + '0'
            } else if (('' + this.initData[val]).split('.')[1].length === 2) {

            } else if (('' + this.initData[val]).split('.')[1].length > 2) {
                const [before, after] = (this.initData[val] + '').split('.')
                this.initData[val] = before + '.' + (after + '').slice(0, 2)
            }
            if ((this.initData[val] + '').length > 20) this.initData[val] = (this.initData[val] + '').slice(0, 20)
        },
        //拒绝非数字的展示
        stopUndefined(val) {
            const num = Number(val)
            if (!num) return '0.00'
            if ((num + '').indexOf('.') < 0) return num + '.00'
            if ((num + '').split('.')[1].length <= 2) return val.toFixed(2)
            const twoFloatPrice = Math.round((num) * 100) / 100
            if((twoFloatPrice + '').indexOf('.') < 0){
                return twoFloatPrice + '.00'
            }else if((twoFloatPrice + '').split('.')[1].length === 1){
                return twoFloatPrice + '0'
            }else{
                return twoFloatPrice
            }
        },
        //只允许输入数字
        importText(val) {
            this.initData[val] = `${(this.initData[val] + '').replace(/\D/g, '')}`
        },
        floatNumCheck(rule, value, cb) {
            if (/^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/.test(value) || value == 0) {
                return cb()
            }
            cb(new Error(this.$t(`message.tabs.floatNumCheck`)))
        },
    },
};
</script>

<style lang="scss" scoped>
.rootBox {
    width: 100%;
    flex-shrink: 0;
    transition: all 0.3s ease;
    .tableBox {
        transition: all 0.3s ease;
        height: 80px;
        overflow: hidden;
        color: #666;
        .itemBox {
            padding: 0 20px;
            margin-bottom: 20px;
            display: flex;
            justify-content: space-between;
            .msgOrInp {
                position: relative;
                display: flex;
                .introduce {
                    margin-right: 10px;
                }
                .inpBox {
                    .selectDifficulty {
                        display: flex;
                    }
                }
                .taxInp {
                    position: relative;
                    .unitSmall {
                        position: absolute;
                        padding-left: 10px;
                        white-space: nowrap;
                    }
                    .timeSmall {
                        font-size: 14px;
                        position: absolute;
                        right: -10px;
                        top: 5px;
                    }
                    .landSmall{
                        position: absolute;
                        top: 6px;
                        padding-left: 10px;
                        font-size: 14px;
                        white-space: nowrap;
                    }
                }
                .timeCharge {
                    display: flex;
                    .timeInp {
                        margin-left: -20px;
                    }
                }
                .explain {
                    line-height: 40px;
                    font-size: 14px;
                    padding-left: 10px;
                    white-space: nowrap;
                    max-width: 700px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    position: absolute;
                    top: 40px;
                    left: 230px;
                    color: #eb0202;
                }
            }
            .resultBox {
                display: flex;
                line-height: 40px;
                .showPrice {
                    min-width: 122px;
                    height: 38px;
                    line-height: 40px;
                    border-radius: 4px;
                    padding: 0 10px;
                    border: 1px solid #dcdfe6;
                }
            }
        }
    }
}
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
}
::v-deep input[type="'number'"] {
    -moz-appearance: textfield !important;
}
::v-deep .el-input__inner {
    width: 270px;
    padding-right: 70px;
}
::v-deep.el-select .el-input__inner {
    width: 100%;
    padding-right: 30px;
}
::v-deep.introduce .el-select .el-input__inner {
    width: 230px;
}
::v-deep.selectDifficulty .beforeSel .el-input__inner {
    width: 80px;
}
.topOne{
    left: 320px !important;
}
.topTwo{
    left: 384px !important;
}
</style>